export const enum GraphQueryColumnName {
  BinnedTimestamp = "binned_timestamp",
  Count = "count",
}
